import { render, staticRenderFns } from "./CmgRewardsExchangeWelcomeModal.vue?vue&type=template&id=21330eba&scoped=true&lang=pug"
import script from "./cmg-rewards-exchange-welcome-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-rewards-exchange-welcome-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRewardsExchangeWelcomeModal.vue?vue&type=style&index=0&id=21330eba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21330eba",
  null
  
)

export default component.exports